import fullNameVue from './index.vue'

const FullToast = {};

FullToast.install = function (Vue, option) {
    const FullNameInstance = Vue.extend(fullNameVue);
    let name;
    const initInstance = () => {
        const query = uni.createSelectorQuery().selectViewport()
        name = new FullNameInstance();
        let nameSpan = name.$mount().$el;
        console.log(document)
        console.log(query)
        document.body.appendChild(nameSpan);
    }
    Vue.prototype.$uToast = {
        showToast(option) {
            initInstance();
            if (typeof option === 'string') {
                name.firstName = option;
            } else if (typeof option === 'object') {
                Object.assign(name, option);
            }
            return initInstance;
        }
    };
}

export default FullToast;